module.exports = __webpack_public_path__ + "img/banner.a5e14a66.png";